export const initialState = {
  data: [],
  errors: undefined,
  loading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'tripFetch': {
      return { ...state, loading: true };
    }
    case 'tripFetchSuccess': {
      return { ...state, loading: false, data: action.payload };
    }
    case 'tripFetchError': {
      return { ...state, loading: true, errors: action.payload };
    }
    default: {
      return state;
    }
  }
}

export { reducer as tripReducer }
